export default __webpack_public_path__ + "static/media/20s_storyicon@3x.0567a875.png";